import { Button } from '@shared/ui/button';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@shared/ui/dialog';
import { dialogFooterClassName, cancelButtonClassName, primaryButtonClassName } from '@shared/ui/formStyles';

export function ConfirmationDialog({
  isOpen,
  title,
  description,
  additionalInfo,
  cancelLabel = 'Cancel',
  confirmLabel = 'Confirm',
  onCancel,
  onConfirm,
  isLoading = false,
  variant = 'default',
  dataTestId,
}) {
  // Confirm takes the app's primary action colour (--color-brand, the Button default) unless the
  // action is destructive, which uses the Button's token-backed `destructive` variant. The old
  // `default` was a grey palette button with no dark-mode colour.
  const confirmVariant = variant === 'danger' ? 'destructive' : 'default';

  return (
    <Dialog open={isOpen} onOpenChange={onCancel}>
      <DialogContent className="sm:max-w-[550px]" data-testid={dataTestId}>
        <DialogHeader className="pb-1">
          <DialogTitle data-testid={dataTestId ? `${dataTestId}-title` : undefined}>{title}</DialogTitle>
        </DialogHeader>

        <div className="py-0">
          <DialogDescription className="mb-0" data-testid={dataTestId ? `${dataTestId}-description` : undefined}>
            {description}
          </DialogDescription>
          {additionalInfo && (
            <p className="text-sm text-warning-fg font-medium mt-3" data-testid={dataTestId ? `${dataTestId}-additional-info` : undefined}>
              {additionalInfo}
            </p>
          )}
        </div>

        <DialogFooter className={`${dialogFooterClassName} !px-0`}>
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            disabled={isLoading}
            className={cancelButtonClassName}
            data-testid={dataTestId ? `${dataTestId}-cancel-button` : undefined}
          >
            {cancelLabel}
          </Button>
          <Button
            type="button"
            variant={confirmVariant}
            onClick={onConfirm}
            disabled={isLoading}
            className={primaryButtonClassName}
            data-testid={dataTestId ? `${dataTestId}-confirm-button` : undefined}
          >
            {isLoading ? 'Processing...' : confirmLabel}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
